import React, { Component } from 'react';

import {
  StyledBoxInside,
  StyledTitleWidget,
  StyledWrapperStationDirectory,
  StyledWrapperPaginator,
  StyledPaginatorVertical,
  StyledTwoLevelBreadcrumb
} from './style';
import { ModalStation } from './ModalStation';
import { OndaceroWhite } from '../../../../../assets/images/index';
import StationTable from './StationTable';
import InfiniteScroller from '../../../core/InfiniteScroller';
import Input from '../../../core/Input';
import Label from '../../../core/Label';

import {
  getStations,
  getStationsScroll,
  getStationsByText,
  getStationsByTextScroll
} from '../../../../utils/apiRadioStations';

class StationDirectory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModalStation: false,
      stations: [],
      total: 0,
      page: 0,
      size: 20,
      text: null,
      station: null
    };
  }

  componentDidMount() {
    getStations()
      .then(data => {
        this.setState({
          stations: data.content,
          total: data.total,
          page: data.page,
          size: data.size
        });
      })
      .catch(() => {});
  }

  closeModalStation = () => {
    this.setState({
      showModalStation: false
    });
  };

  onClickDetail = data => {
    this.setState({
      showModalStation: true,
      station: data
    });
  };

  onReturnServices = () => {
    this.props.history.push('/servicios-onda-cero');
  };

  loadMore = () => {
    const { stations, size, page, text } = this.state;
    if (text !== null) {
      getStationsByTextScroll(text, page + 1, size)
        .then(data => {
          this.setState({
            stations: stations.concat(data.content),
            total: data.total,
            page: data.page,
            size: data.size
          });
        })
        .catch(() => {});
    } else {
      getStationsScroll(page + 1, size)
        .then(data => {
          this.setState({
            stations: stations.concat(data.content),
            total: data.total,
            page: data.page,
            size: data.size
          });
        })
        .catch(() => {});
    }
  };

  searchBytext = txt => {
    const { size } = this.state;
    this.setState({ text: txt });
    getStationsByText(txt, size)
      .then(data => {
        this.setState({
          stations: data.content,
          total: data.total,
          page: data.page,
          size: data.size
        });
      })
      .catch(() => {});
  };

  controlModalDetail = e => {
    this.setState({
      showModalStation: e
    });
  };

  controlVisibleItem = () => {
    const { size, page, total } = this.state;
    if (page === 0) {
      if (total < size) {
        return total;
      }
      return size;
    }
    if (size * (page + 1) > total) {
      return total;
    }
    return size * (page + 1);
  };

  render() {
    const {
      showModalStation,
      stations,
      total,
      size,
      page,
      station
    } = this.state;

    return (
      <div className="pressResume_container">
        <StyledBoxInside>
          <StyledTitleWidget
            title="Consulta de emisoras"
            type="ondacero"
            icon={OndaceroWhite}
            small
          />
          <StyledTwoLevelBreadcrumb
            first="Servicios Onda Cero"
            second="Consulta de emisoras"
            onBack={this.onReturnServices}
          />
          <StyledWrapperStationDirectory>
            <form className="form-search" action="#">
              <Label label="Buscar" htmlFor="search" className="mb-5" />
              <Input
                id="search"
                name="search"
                className="mb-10"
                placeholder="Introduzca el texto..."
                onChange={e => this.searchBytext(e)}
              />
            </form>
            <InfiniteScroller
              loadMore={() => this.loadMore()}
              hasMore={page * size > total}
            >
              {stations && (
                <StationTable
                  stationDirectory={stations}
                  onClickDetail={data => this.onClickDetail(data)}
                />
              )}
            </InfiniteScroller>
          </StyledWrapperStationDirectory>
          <StyledWrapperPaginator>
            {stations && (
              <StyledPaginatorVertical
                visibleItems={this.controlVisibleItem()}
                totalItems={total}
              />
            )}
          </StyledWrapperPaginator>
        </StyledBoxInside>
        {showModalStation && station && (
          <ModalStation
            stationDetail={station}
            setShowModalStation={e => this.controlModalDetail(e)}
          />
        )}
      </div>
    );
  }
}

export default StationDirectory;
